export default "__VITE_ASSET__91f700cb__"